// Un <input type="date"> devuelve "YYYY-MM-DD". new Date("YYYY-MM-DD") lo toma
// como medianoche UTC, que en República Dominicana (UTC-4) es el día ANTERIOR a
// las 8:00 p. m.: getDay() da el día de la semana equivocado y las fechas se
// corren un día. Estas funciones trabajan siempre en hora local.

export const parseFechaLocal = (valor) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(valor || '');
  return m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : null;
};

// "YYYY-MM-DD" de hoy + `dias` en hora local (para el atributo min de los inputs).
export const fechaISOLocal = (dias = 0) => {
  const d = new Date();
  d.setDate(d.getDate() + dias);
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
};

// Fecha "YYYY-MM-DD" → "dd/mm/aaaa" sin pasar por zonas horarias.
export const formatearFechaISO = (valor) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(valor || '');
  return m ? `${m[3]}/${m[2]}/${m[1]}` : '—';
};
